import BaseEnum from "./base_enum.js";

class DeletionStatusFilterModeEnumDesc extends BaseEnum {

  name() {
    return "deletion_status_filter_mode";
  }

  rawValues() {
    return ["true", "false"];
  }

}

const DeletionStatusFilterModeEnum = new DeletionStatusFilterModeEnumDesc();
export default DeletionStatusFilterModeEnum;
